import React, { forwardRef } from "react";
import { Stack, Divider } from "@mui/material";
import StyledButton from "../../../../Reuse/UI/StyledButton";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { StyledFormControl, StyledTextInput } from "../../../../Reuse/FormInput";
import { useWatch } from "react-hook-form";

const RangeInput = forwardRef(
  ({ label, parentId, setValue, control }, ref) => {
    const from = useWatch({ control, name: `${parentId}_from` });
    const to = useWatch({ control, name: `${parentId}_to` });

    const clear = async () => {
      setValue(`${parentId}_from`, null, { shouldDirty: true, shouldValidate: true });
      setValue(`${parentId}_to`, null, { shouldDirty: true, shouldValidate: true });
    };

    // Allow only number keys and control keys
    const handleKeyDown = (e) => {
      const allowedKeys = [
        "Backspace", "Tab", "ArrowLeft", "ArrowRight", "Delete", "Home", "End"
      ];
      const isNumber = /^[0-9]$/.test(e.key);
      if (!isNumber && !allowedKeys.includes(e.key)) {
        e.preventDefault();
      }
    };

    return (
      <StyledFormControl label={label} id={parentId}>
        <Stack direction="row" alignItems="center" gap={2}>
          <StyledTextInput
            name={`${parentId}_from`}
            control={control}
            showLabel={false}
            placeholder="From"
            type="text" // set to "text" to prevent native browser issues
            rules={{ valueAsNumber: true }}
            onKeyDown={handleKeyDown}
          />

          <Divider sx={{ width: 8, borderColor: "#101828" }} />

          <StyledTextInput
            name={`${parentId}_to`}
            control={control}
            showLabel={false}
            placeholder="To"
            type="text"
            rules={{ valueAsNumber: true }}
            onKeyDown={handleKeyDown}
          />

          {(from || to) && (
            <StyledButton
              variant="text"
              startIcon={<ClearRoundedIcon />}
              onClick={clear}
            >
              Clear
            </StyledButton>
          )}
        </Stack>
      </StyledFormControl>
    );
  }
);

export default RangeInput;
